export default __webpack_public_path__ + "static/icono_redondo_autor-80ac5df1b839a26c74d52da471ce2a91.png";